
import React, { Component } from 'react'; 
import AdmHelper from '@model/helper/AdmHelper';
import '@styles/adm/shared/selectTranslation.scss'; 

export class SelectTranslation extends Component {
    static displayName = SelectTranslation.name;

    constructor(props) {
        super(props);

        this.textCacheKey = this.props.isFile ? 'files_filter_text' : 'translations_filter_text';
        this.default = { id: 'default' };

        this.state = {
            filteredList: [],
            open: false,
            selected: this.default,
            filterText: '',

            cursorInList: false,

            listRef: React.createRef(),
            listHeight: 100,

            placeholder: 'Filtrovat záznamy',
        };

        this.helper = new AdmHelper();
    }

    GetCachedFilterText = () => {
        let text = localStorage.getItem(this.textCacheKey);
        if (typeof text != typeof 'string')
            return;

        this.HandleFilter(text);
    }

    componentDidMount() {
        window.addEventListener('click', this.OnClick);

        let list = this.GetAllTranslations();
        this.setState((prevState) => ({ ...prevState, filteredList: list }));

        let preselected = list.find(t => t.id === this.props.selectedId);
        if(preselected)
            this.OnSelect(preselected);
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevState.selected != this.state.selected) {
            let selectedName = this.GetTranslationDisplayName(this.state.selected);
            this.setState((prevState) => ({ ...prevState, placeholder: selectedName }));
            this.HandleFilter(this.state.filterText)
        }

        if (prevState.filteredList != this.state.filteredList) {
            let listHeight = (this.state.filteredList.length + 0) * 34;
            if (this.state.filteredList.length <= 0)
                listHeight = 34;
            this.setState((prevState) => ({ ...prevState, listHeight: listHeight }));
        }
    }

    GetAllTranslations = () => {

        // filtrace jiz selectnuty translation
        let translations = [...this.props.translationList];

        if(this.state.selected.id !== 'default')
            translations.splice(0, 0, this.default);

        //let filtered = translations.filter(t => t.id !== this.state.selected.id);
        let filtered = translations;
        return filtered;
    }

    OnClick = () => {
        if (!this.state.cursorInList)
            this.HandleSetOpen(false)
    }

    HandleSetOpen = (val) => {

        if (val == true) {

            if (this.state.selected.id === 'default') {
                this.GetCachedFilterText();
            } else {
                this.HandleFilter('');
            }
        }

        this.setState((prevState) => ({ ...prevState, open: val }));
    }

    HandleToggleOpen = () => {
        this.HandleSetOpen(!this.state.open);
    }

    HandleFilter = (text, saveTextToCache = false) => {

        let allTranslations = this.GetAllTranslations();
        let filtered = [];
        for (let i in allTranslations) {
            let t = allTranslations[i];

            if (t.id === 'default') {
                filtered.push(t);
                continue;
            }

            // filtr podle GetTranslationDisplayName
            if (this.GetTranslationDisplayName(t).toLowerCase().includes(text.toLowerCase())) {
                filtered.push(t);
                continue;
            }               

            // filter podle key
            if (t.key && t.key.toLowerCase().includes(text.toLowerCase())) {
                filtered.push(t);
                continue;
            }

            // filter podle localizace
            let locFound = false;
            for (let j in t.localizationList) {

                if (locFound)
                    continue;

                let l = t.localizationList[j];
                if (l.value.toLowerCase().includes(text.toLowerCase())) {
                    locFound = true;
                    filtered.push(t);
                }
            }
        }

        if (saveTextToCache)
            localStorage.setItem(this.textCacheKey, text);

        this.setState((prevState) => ({ ...prevState, filterText: text, filteredList: filtered }));
    }

    RenderCircle = (color) => {
        return <div className={`colorCircle ${color} ms-1`}></div>
    }

    OnSelect = (t) => {
        this.setState((prevState) => ({ ...prevState, selected: t }));
        this.HandleFilter(this.state.filterText);
        this.HandleSetOpen(false);
        this.props.OnChange(t.id);
    }

    RenderTranslationListRow = (t) => {
        return <span role='button' className={`ps-2 ${t.id === 'default' && 'redText'}`} key={t.id} value={t.id} onClick={() => this.OnSelect(t)}>{this.GetTranslationDisplayName(t)}</span>
    }

    GetTranslationDisplayName = (t) => {

        if (t.id === 'default') {

            if (this.state.selected.id === t.id)
                return this.props.optional ? 'Vyberte (nepovinné)' : 'Vyberte';

            return `Odebrat ${this.props.isFile ? '' : 'překlad'}`;
        }

        if (this.props.isFile) {
            return t.id;
        }

        return `${t.key} ${this.props.withNote ? `-> ${this.helper.GetLocalizationCzechOrOtherShort(t)} ` : ''} ${!t.isActive ? '(Neaktivní)' : ''} ${!t.isComplete ? '(Nekompletní)' : ''}`;                 
    }

    HandleSetCursorInList = (val) => {
        this.setState((prevState) => ({ ...prevState, cursorInList: val }));
    }

    render() {
        let target = this.props.translationList.find(t => t.id == this.props.selectedId);
        let colorCircle;
        let color;
        if (!target || target.id === 'default') {
            color = this.props.optional ? 'grayDarker' : 'red'
        } else {
            if (this.props.isFile) {
                color = 'green';
            } else {
                color = ((!target.isActive && !this.props.optional) || !target.isComplete) ? 'red' : 'green';
            }
        }

        colorCircle = this.RenderCircle(color);
                          
        return (
            <div className={`selectTranslation d-flex flex-column ${this.props.mb2 ? 'mb-2' : 'mb-3'}`}>
                <span className=''>{this.props.text}</span>
                <div className='headCircleContainer d-flex align-items-center justify-content-between' onMouseEnter={() => this.HandleSetCursorInList(true)} onMouseLeave={() => this.HandleSetCursorInList(false)}>

                    {this.state.open ?
                        <div className={`search col d-flex align-items-center justify-content-between ${color}`}>
                            <i className="searchIcon fa-solid fa-magnifying-glass"></i>
                            <input autoFocus type='text' className={`col`} placeholder={this.state.placeholder} value={this.state.filterText} onChange={(e) => this.HandleFilter(e.target.value, true)} />
                            <i className="closeIcon fa-solid fa-xmark" onClick={() => this.HandleFilter('', true)}></i>
                        </div>
                        :
                        <div role='button'
                            className={`head ${color} ${this.state.open ? 'fw-bold' : ''} col ps-2 p-1 d-flex align-items-center justify-content-between me-1 ${((this.state.selected === null && !this.props.optional) || this.state.selected?.isActive === false || this.state.selected?.isComplete === false) && 'warning'}`}
                            onClick={() => this.HandleToggleOpen()}
                        >
                            {this.GetTranslationDisplayName(this.state.selected)}
                            <i role='button' className={`${this.state.open && 'up'} p-1 fa-solid fa-chevron-down me-1`}></i>
                        </div>
                    }

                    {colorCircle}

                    <div
                        className={`list d-flex flex-column w-100 ${this.state.open ? 'open' : ''}`}
                        ref={this.state.listRef}
                        style={{
                            height: this.state.open ? `${this.state.listHeight}px` : '0px',
                        }}
                    >
                        {this.state.filteredList.map(translation => {
                            return (
                                this.RenderTranslationListRow(translation)
                            );
                        })}
                        {this.state.filteredList.length <= 0 &&
                            <span className='ps-2'>Nebyl nalezen žádný záznam</span>
                        }
                    </div>
                </div>
            </div>
        );
    }

}
